import { Tooltip } from "@mui/material";
import { WarningAmberRounded as WarningIcon } from "@mui/icons-material";

import type { AdminVendorConnection } from "types/interfaces/adminUsers";

import { connectionProblemSummary } from "./connectionFields";

/** A saved login that breaks its vendor's rules (CAL-6158): what its bots
 *  would miss, said on hover; nothing at all for a login that is fine. */
export default function ConnectionProblemFlag({
  connection,
}: {
  connection: Pick<AdminVendorConnection, "problems"> | null | undefined;
}) {
  const summary = connectionProblemSummary(connection?.problems);
  if (!summary) return null;
  return (
    <Tooltip title={summary}>
      <WarningIcon
        color="warning"
        fontSize="small"
        role="img"
        aria-label={`Breaks its vendor's rules: ${summary}`}
        sx={{ verticalAlign: "middle", ml: 0.5, flexShrink: 0 }}
      />
    </Tooltip>
  );
}
